import { RefObject, MouseEvent } from "react";
import {
  GroupBase,
  OptionProps,
  SelectInstance,
  components,
} from "react-select";
import SelectOption from "./select-option";
import classNames from "classnames";

type SelectOptionComponentProps<IsMulti extends boolean> = OptionProps<
  SelectOption,
  IsMulti,
  GroupBase<SelectOption>
> & {
  selectRef: RefObject<SelectInstance<
    SelectOption,
    IsMulti,
    GroupBase<SelectOption>
  > | null>;
};

const SelectOptionComponent = <IsMulti extends boolean>(
  props: SelectOptionComponentProps<IsMulti>,
) => {
  const Option = components.Option as React.ComponentType<
    OptionProps<SelectOption, IsMulti, GroupBase<SelectOption>>
  >;

  const handleOnClick = (event: MouseEvent<HTMLDivElement>) => {
    if (!props.data.onClick) return;
    props.data.onClick(event);
    props.selectRef.current?.blur();
  };

  return (
    <Option
      {...props}
      innerProps={{
        ...props.innerProps,
        onClick: props.data.onClick ? handleOnClick : props.innerProps.onClick,
        ...({
          "data-testid": props.data.idForTesting,
        } as React.HTMLAttributes<HTMLDivElement>),
      }}
      className={classNames(props.className, "select__option")}
    >
      <div className="label" title={props.data.label}>
        {props.data.label}
      </div>
      {props.data.subText && (
        <div className="subtext">{props.data.subText}</div>
      )}
    </Option>
  );
};

export default SelectOptionComponent;
